<script setup>
import {ref, computed} from 'vue'

const props = defineProps({
  domain: String
})
const email = ref('')
const formId = Math.random().toString(16).slice(2);
const selected = ref('tarifrechner');
const options = ref([
  {text: 'Haushaltsstrom', value: 'tarifrechner'},
  {text: 'Autostrom', value: 'tarifrechner/autostrom'},
  {text: 'Wärmestrom', value: 'tarifrechner/waermestrom'}
]);
const isEmailValid = computed(() => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email.value);
});
</script>
<template>
  <form>
    <div class="row">
      <div class="col-12 col-md-6">
        <label
            :for="'type_' + formId"
            class="form-label"
        >
          Energieart
        </label>
        <select
            v-model="selected"
            class="form-select form-select-lg"
            :id="'type_' + formId"
        >
          <option
              v-for="option in options"
              :key="option.value"
              :value="option.value"
          >
            {{ option.text }}
          </option>
        </select>
      </div>
      <div class="col-12 col-md-6 pt-3 pt-md-0">
        <label
            :for="'email_' + formId"
            class="form-label"
        >
          E-Mail Adresse
        </label>
        <input
            v-model="email"
            type="email"
            class="form-control form-control-lg"
            :class="{ 'is-invalid': (email && !isEmailValid) }"
            :id="'email_' + formId"
        >
        <div
            v-if="email && !isEmailValid"
            class="text-danger"
        >
          Bitte eine gültige E-Mail-Adresse eingeben.
        </div>
      </div>
    </div>
  </form>
  <p class="pt-4">
    Dein Werbelink:
  </p>
  <p class="align-items-center">
    <button
        class="btn btn-link btn-vs-link vs-clipboard-btn"
        v-if="isEmailValid"
        :data-clipboard-text="props.domain + selected + '?acquired_from=' + email"
        title="Werbelink im Zwischenspeicher speichern."
    >
      <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-floppy-fill"
          viewBox="0 0 16 16"
          width="30"
      >
        <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0H3v5.5A1.5 1.5 0 0 0 4.5 7h7A1.5 1.5 0 0 0 13 5.5V0h.086a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5H14v-5.5A1.5 1.5 0 0 0 12.5 9h-9A1.5 1.5 0 0 0 2 10.5V16h-.5A1.5 1.5 0 0 1 0 14.5z"/>
        <path d="M3 16h10v-5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5zm9-16H4v5.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5zM9 1h2v4H9z"/>
      </svg>
    </button>
    <span v-if="isEmailValid">
      {{ props.domain + selected + '?acquired_from=' + email }}
    </span>
  </p>
</template>
<style scoped>
.text-danger {
  color: red;
}
</style>